import React, { useEffect, useState } from "react";
import Select from "react-select";
import * as func from "../../common/athleteCommon/FunctionCalls";

interface Props {
    formData: any;
    onChange: (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => void;
}

const InjuryProfile: React.FC<Props> = ({ formData, onChange }) => {

    // const injuryTypeList = [{ injTypId: 1, injTypName: "Acute" }, { injTypId: 2, injTypName: "Overuse/Chronic" }, { injTypId: 3, injTypName: "Recurrent" }]
    // const affectedRegionList = [{ aftcdRgnId: 1, aftcdRgnName: "Head" }, { aftcdRgnId: 2, aftcdRgnName: "Face" }, { aftcdRgnId: 3, aftcdRgnName: "Cervical Spine/ Neck" },
    // { aftcdRgnId: 4, aftcdRgnName: "Shoulder" }, { aftcdRgnId: 5, aftcdRgnName: "Upper Arm" }, { aftcdRgnId: 6, aftcdRgnName: "Elbow" }, { aftcdRgnId: 7, aftcdRgnName: "Forearm" },
    // { aftcdRgnId: 8, aftcdRgnName: "Wrist" }, { aftcdRgnId: 9, aftcdRgnName: "Hand/ Fingers" }, { aftcdRgnId: 10, aftcdRgnName: "Thoracic spine" }, { aftcdRgnId: 11, aftcdRgnName: "Lumbar Spine" },
    // { aftcdRgnId: 12, aftcdRgnName: "Pelvis" }, { aftcdRgnId: 13, aftcdRgnName: "Hip" }, { aftcdRgnId: 14, aftcdRgnName: "Thigh" }, { aftcdRgnId: 15, aftcdRgnName: "Knee" }, { aftcdRgnId: 16, aftcdRgnName: "Lower Leg" }, { aftcdRgnId: 17, aftcdRgnName: "Ankle" }, { aftcdRgnId: 18, aftcdRgnName: "Foot/ toes" }]
    // const diagnosisList = [{ diagnosisId: 1, diagnosisName: "Concussion" }, { diagnosisId: 2, diagnosisName: "Ligament Sprain" }, { diagnosisId: 3, diagnosisName: "Muscle Strain" }, { diagnosisId: 4, diagnosisName: "Tendinopathy" }, { diagnosisId: 5, diagnosisName: "Fracture" }, { diagnosisId: 6, diagnosisName: "Dislocation" }, { diagnosisId: 7, diagnosisName: "Subluxation" },
    // { diagnosisId: 8, diagnosisName: "Contusion" }, { diagnosisId: 9, diagnosisName: "Nerve Injury" }, { diagnosisId: 10, diagnosisName: "Meniscus Injury" }, { diagnosisId: 11, diagnosisName: "Cartilage Injury" }, { diagnosisId: 12, diagnosisName: "Stress fracture" }]
    // const severityList = [{ severityId: 1, severityName: "Mild" }, { severityId: 2, severityName: "Moderate" }, { severityId: 3, severityName: "Severe" }]
    // const injuryMechanismList = [{ injMechId: 1, injMechName: "Contact" }, { injMechId: 2, injMechName: "Non-contact" }, { injMechId: 3, injMechName: "Overuse" }, { injMechId: 4, injMechName: "Collision" }, { injMechId: 5, injMechName: "Fall" }, { injMechId: 6, injMechName: "Equipment-related" }, { injMechId: 7, injMechName: "Environment-related" }]
    // const injuryMgmtList = [{ injMgmtId: 1, injMgmtName: "RICE protocol" }, { injMgmtId: 2, injMgmtName: "Physiotherapy" }, { injMgmtId: 3, injMgmtName: "Medication" }, { injMgmtId: 4, injMgmtName: "Immobilization" }, { injMgmtId: 5, injMgmtName: "Injection Therapy" }, { injMgmtId: 6, injMgmtName: "Surgery" }, { injMgmtId: 7, injMgmtName: "Other" }]
    // const timeLostList = [{ timelostId: 1, timelostName: "No time lost" }, { timelostId: 2, timelostName: "1 - 3 weeks" }, { timelostId: 3, timelostName: "3-6 weeks" }, { timelostId: 4, timelostName: "More than 6 weeks" }]

    const [injuryTypeList, setInjuryTypeList] = useState < any[] > ([]);
    const [affectedRegionList, setAffectedRegionList] = useState < any[] > ([]);
    const [diagnosisList, setDiagnosisList] = useState < any[] > ([]);
    const [severityList, setSeverityList] = useState < any[] > ([]);
    const [injuryMechanismList, setInjuryMechanismList] = useState < any[] > ([]);
    const [injuryMgmtList, setInjuryMgmtList] = useState < any[] > ([]);
    const [timeLostList, setTimeLostList] = useState < any[] > ([]);

    useEffect(() => {
        async function getInjProfile() {
            const injResponse = await func.injuryType(null);
            setInjuryTypeList(Array.isArray(injResponse) ? injResponse : []);
            const afctdResponse = await func.regionAffected(null);
            setAffectedRegionList(Array.isArray(afctdResponse) ? afctdResponse : []);
            const diagResponse = await func.diagnosisType(null);
            setDiagnosisList(Array.isArray(diagResponse) ? diagResponse : []);
            const svrtyResponse = await func.injurySeverity(null);
            setSeverityList(Array.isArray(svrtyResponse) ? svrtyResponse : []);
            const mechResponse = await func.injuryMechanism(null);
            setInjuryMechanismList(Array.isArray(mechResponse) ? mechResponse : []);
            const mgmtResponse = await func.injuryManagement(null);
            setInjuryMgmtList(Array.isArray(mgmtResponse) ? mgmtResponse : []);
            const timeResponse = await func.timeLost(null);
            setTimeLostList(Array.isArray(timeResponse) ? timeResponse : []);
        }
        getInjProfile();
    }, [])

    const handleSelectChange = (name: string) =>
        (option: any) => {
            const value = Array.isArray(option)
                ? option.map(o => o.value)
                : option?.value ?? "";

            onChange({
                target: { name, value }
            } as React.ChangeEvent<HTMLInputElement>);
        };

    return (
        <>
            <div className="card-tableset" style={{ padding: "10px" }}>
                <div className="card-body">

                    <div className="row">
                        <div className="col-lg-4">
                            <h4>Is there no Injury history?</h4>
                        </div>
                        <div className="col-lg-2">
                            <div className="form-check form-switch d-flex align-items-center justify-content-start">
                                <input
                                    className="form-check-input text-end"
                                    type="checkbox"
                                    checked={formData.noHistory === '1'}
                                    name="noHistory"
                                    // onChange={onChange}
                                    onChange={(e) =>
                                        onChange({
                                            target: {
                                                name: "noHistory",
                                                value: e.target.checked ? "1" : "0"
                                            }
                                        } as React.ChangeEvent<HTMLInputElement>)
                                    }
                                />
                            </div>
                        </div>
                    </div>
                    {(formData.noHistory != "1") ?
                        <>
                            <div className="row">
                                <div className="col-lg-4">
                                    <label className="form-label">Injury Description</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        style={{ border: "1px solid hsl(0, 0%, 80%)", height: "40px" }}
                                        name="injuryDescription"
                                        required
                                        value={formData.injuryDescription}
                                        onChange={onChange}
                                        placeholder="Enter Injury Description" />
                                </div>
                                <div className="col-lg-4">
                                    <label className="form-label">Date of Injury</label>
                                    <input
                                        type="date"
                                        className="form-control"
                                        style={{ border: "1px solid hsl(0, 0%, 80%)", height: "40px" }}
                                        name="dateOfInjury"
                                        required
                                        value={formData.dateOfInjury}
                                        onChange={onChange}
                                        placeholder="Enter Date of injury" />
                                </div>
                                <div className="col-lg-4">
                                    <label className="form-label">Date of return to sports</label>
                                    <input
                                        type="date"
                                        className="form-control"
                                        style={{ border: "1px solid hsl(0, 0%, 80%)", height: "40px" }}
                                        name="dateOfReturnToSports"
                                        required
                                        value={formData.dateOfReturnToSports}
                                        onChange={onChange}
                                        placeholder="Enter Date of Return" />
                                </div>
                                <div className="col-lg-4">
                                    <label className="form-label">Summary of Treatment</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        style={{ border: "1px solid hsl(0, 0%, 80%)", height: "40px" }}
                                        name="summaryOfTreatment"
                                        required
                                        value={formData.summaryOfTreatment}
                                        onChange={onChange}
                                        placeholder="Enter Summary of Treatment" />
                                </div>
                                <div className="col-lg-4">
                                    <label className="form-label">Summary of Recovery Process</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        style={{ border: "1px solid hsl(0, 0%, 80%)", height: "40px" }}
                                        name="summaryOfRecoveryProcess"
                                        required
                                        value={formData.summaryOfRecoveryProcess}
                                        onChange={onChange}
                                        placeholder="Enter Summary of Recover Process" />
                                </div>
                                <div className="col-lg-4">
                                    <label className="form-label">Injury Type</label>
                                    <Select
                                        value={injuryTypeList.find(inj => inj.injuryTypeId === formData.injuryType) ? {
                                            value: formData.injuryType,
                                            label: injuryTypeList.find(inj => inj.injuryTypeId === formData.injuryType)?.name
                                        } : null}
                                        onChange={handleSelectChange("injuryType")}
                                        required
                                        placeholder="Select Injury Type"
                                        options={injuryTypeList.map(inj => ({
                                            value: inj.injuryTypeId,
                                            label: inj.name
                                        }))}>
                                    </Select>
                                </div>
                                <div className="col-lg-4">
                                    <label className="form-label">Region Affected</label>
                                    <Select
                                        isMulti
                                        value={Array.isArray(affectedRegionList)
                                            ? affectedRegionList
                                                .filter(afctd => formData.regionAffected.includes(afctd.regionAffectedId))
                                                .map(afctd => ({
                                                    value: afctd.regionAffectedId,
                                                    label: afctd.name
                                                }))
                                            : []
                                        }
                                        onChange={handleSelectChange("regionAffected")}
                                        options={Array.isArray(affectedRegionList)
                                            ? affectedRegionList.map(afctd => ({
                                                value: afctd.regionAffectedId,
                                                label: afctd.name
                                            }))
                                            : []
                                        }
                                    />
                                </div>
                                <div className="col-lg-4">
                                    <label className="form-label">Diagnosis</label>
                                    <Select
                                        isMulti
                                        value={Array.isArray(diagnosisList)
                                            ? diagnosisList
                                                .filter(diag => formData.diagnosis.includes(diag.diagnosisTypeId))
                                                .map(diag => ({
                                                    value: diag.diagnosisTypeId,
                                                    label: diag.name
                                                }))
                                            : []
                                        }
                                        onChange={handleSelectChange("diagnosis")}
                                        options={Array.isArray(diagnosisList)
                                            ? diagnosisList.map(diag => ({
                                                value: diag.diagnosisTypeId,
                                                label: diag.name
                                            }))
                                            : []
                                        }
                                    />
                                </div>
                                <div className="col-lg-4">
                                    <label className="form-label">Injury Severity</label>
                                    <Select
                                        value={severityList.find(svrty => svrty.injurySeverityId === formData.injurySeverity) ? {
                                            value: formData.injurySeverity,
                                            label: severityList.find(svrty => svrty.injurySeverityId === formData.injurySeverity)?.name
                                        } : null}
                                        onChange={handleSelectChange("injurySeverity")}
                                        required
                                        placeholder="Select Injury Severity"
                                        options={severityList.map(svrty => ({
                                            value: svrty.injurySeverityId,
                                            label: svrty.name
                                        }))}>
                                    </Select>
                                </div>
                                <div className="col-lg-4">
                                    <label className="form-label">Mechanism of Injury</label>
                                    <Select
                                        value={injuryMechanismList.find(mech => mech.mechanismInjuryId === formData.mechanismOfInjury) ? {
                                            value: formData.mechanismOfInjury,
                                            label: injuryMechanismList.find(mech => mech.mechanismInjuryId === formData.mechanismOfInjury)?.name
                                        } : null}
                                        onChange={handleSelectChange("mechanismOfInjury")}
                                        required
                                        placeholder="Select Mechanism of Injury"
                                        options={injuryMechanismList.map(mech => ({
                                            value: mech.mechanismInjuryId,
                                            label: mech.name
                                        }))}>
                                    </Select>
                                </div>
                                <div className="col-lg-4">
                                    <label className="form-label">Injury Management Approach</label>
                                    <Select
                                        value={injuryMgmtList.find(mgmt => mgmt.injuryManagementApproachId === formData.injuryManagementApproach) ? {
                                            value: formData.injuryManagementApproach,
                                            label: injuryMgmtList.find(mgmt => mgmt.injuryManagementApproachId === formData.injuryManagementApproach)?.name
                                        } : null}
                                        onChange={handleSelectChange("injuryManagementApproach")}
                                        required
                                        placeholder="Select Injury Management Approach"
                                        options={injuryMgmtList.map(mgmt => ({
                                            value: mgmt.injuryManagementApproachId,
                                            label: mgmt.name
                                        }))}>
                                    </Select>
                                </div>
                                <div className="col-lg-4">
                                    <label className="form-label">Time Lost from training/ competition</label>
                                    <Select
                                        value={timeLostList.find(time => time.timeLostFromTrainingId === formData.timeLostFromTraining_Competition) ? {
                                            value: formData.timeLostFromTraining_Competition,
                                            label: timeLostList.find(time => time.timeLostFromTrainingId === formData.timeLostFromTraining_Competition)?.name
                                        } : null}
                                        onChange={handleSelectChange("timeLostFromTraining_Competition")}
                                        required
                                        placeholder="Select Time Lost"
                                        options={timeLostList.map(time => ({
                                            value: time.timeLostFromTrainingId,
                                            label: time.name
                                        }))}>
                                    </Select>
                                </div>
                            </div>
                        </> : null}
                </div>
            </div>
        </>
    );
};

export default InjuryProfile;